import { Box, Button, Heading, VStack } from '@chakra-ui/react';

function navigateToLogin() {
  window.location.assign('/login');
}

export default function SessionInvalidatedPage() {
  return (
    <Box
      minHeight="100vh"
      display="flex"
      alignItems="center"
      justifyContent="center"
      px="24px"
      bg="white"
    >
      <VStack gap="16px" maxWidth="560px" textAlign="center">
        <Heading size="lg">You have been logged out</Heading>
        <Button onClick={navigateToLogin} width="100%" maxWidth="320px">
          Go to login
        </Button>
      </VStack>
    </Box>
  );
}
